import { createSelector } from 'reselect'
import getCheckoutLoyaltyEarnOrderContext from 'checkout/selectors/loyalty/pointsCalculation/getCheckoutLoyaltyEarnOrderContext'

/**
 * The region sent with earn requests. svc-lux-loyalty uses it to classify payment methods, and treats
 * every payment as high cost without one. Post-purchase checkouts use the original order's region.
 */
const getLoyaltyEarnRegion = createSelector(
  (state: App.State) => getCheckoutLoyaltyEarnOrderContext(state)?.region,
  (state: App.State) => state.geo.currentRegionCode,
  (orderRegion, currentRegion): string => orderRegion ?? currentRegion,
)

export default getLoyaltyEarnRegion
